import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { App } from './App'
import { FaqPage } from './pages/Faq'
import { BlogPage } from './pages/Blog'
import { ChatGptStoragePost } from './pages/blog/ChatGptStorage'
import { ClaudeDataPolicyPost } from './pages/blog/ClaudeDataPolicy'
import { AiSafetyGuidePost } from './pages/blog/AiSafetyGuide'
import { AgenticAiRiskPost } from './pages/blog/AgenticAiRisk'
import { PrivacyPage } from './pages/Privacy'
import { TermsPage } from './pages/Terms'
import { AboutPage } from './pages/About'

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/does-chatgpt-store-your-conversations" element={<ChatGptStoragePost />} />
        <Route path="/blog/what-happens-to-data-you-paste-into-claude" element={<ClaudeDataPolicyPost />} />
        <Route path="/blog/how-to-use-ai-safely-with-confidential-documents" element={<AiSafetyGuidePost />} />
        <Route path="/blog/agentic-ai-and-the-data-privacy-problem" element={<AgenticAiRiskPost />} />
      </Routes>
    </BrowserRouter>
  )
}
